module.exports = __webpack_public_path__ + "static/media/piscines_cosgaya_web.0abc5105.png";